import { SortedSource } from './SortedSource.mjs';

class SortedWritableSource extends SortedSource {
    add(settings) {
        super.add(settings);
    }
}

export { SortedWritableSource };
//# sourceMappingURL=SortedWritableSource.mjs.map
